module.exports = __webpack_public_path__ + "static/img/wei.4d5f19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cec2022/wei.png
// module id = r2nN
// module chunks = 3